import { inject, Injectable, Signal } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { LignesApiService } from "./lignes-api.service";
import { LignesStoreService, LigneState } from "./lignes-store.service";
import { Ligne } from "../../models/ligne.model";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";
import { LigneParam } from "../../../ligne-param/models/ligne-param.model";

@Injectable({ providedIn: "root" })
export class LignesFacadeService extends EntityFacadeService<
  Ligne,
  LignesApiService,
  LigneState,
  EntityMetadata,
  LignesStoreService
> {
  constructor() {
    const api = inject(LignesApiService);
    const store = inject(LignesStoreService);
    super(api, store);
    this.store.initStatus(LignesFacadeService);
  }

  initState() {
    this.store.patchState({
      stats: null,
    });
  }

  @Untrack
  @UpdateStatus
  async saveParamLigne(param: LigneParam) {
    const ligne = await this.api.saveParamLigne(param);
    this.store.upsertOne({ ...ligne });
    return ligne;
  }

  @Untrack
  @UpdateStatus
  async deleteParamLigne(param: LigneParam) {
    const ligne = await this.api.deleteParamLigne(param);
    this.store.upsertOne({ ...ligne });
    return ligne;
  }

  @Untrack
  @UpdateStatus
  async stats(payload: {
    ligneId: string;
    dateDebut: Date;
    dateFin: Date;
  }) {
    const stats = await firstValueFrom(this.api.stats(payload));
    this.store.getWritableState().stats.set(stats);
  }
}
